<div
    *ngrxLet="command() as currentCommand"
    class="st-read-rate-command-dialog__body">
    <st-text-field
        showLinks
        [label]="ProductionCommandsDefaultLabels[currentCommand.commandType]"
        [value]="currentCommand[ProductionFieldName.TEXT]"
        (onEnter)="onEnterSaveCommand($event)"
        (changed)="onCommandsObjectChange($event, ProductionFieldName.TEXT)" />
</div>
